<template>
    <van-uploader
            class="uploader"
            :before-read="beforeRead"
            :after-read="uploadFile"
            :before-delete="deleteCl"
            v-model="fileList"
            :max-count="maxCount"
    ></van-uploader>
</template>

<script>

    import {Notify} from 'vant'

    export default {
        name: "uploadFile",
        data() {
            return {
                fileList: []
            }
        },
        props: {
            // 是否为保全
            isBQ: {
                type: Boolean,
                required: true,
            },
            id: {
                type: String,
                required: true,
            },
            // 上传接口
            uploadUrl: {
                type: String,
                required: true,
            },
            // 删除接口
            delUrl: {
                type: String,
                required: true,
            },
            // 材料类型
            cllx: {
                type: String,
                required: true,
            },
            // id对应的字段
            keyName: {
                type: String,
                required: true,
            },
            //
            maxCount:{
                type: Number,
                required: false,
                default: 5
            },
            list: {
                type: Array,
                required: true
            }
        },
        methods: {
            // 上传材料状态控制
            uploadStatus(clid, status = null, message = null) {
                let length = this.fileList.length
                this.fileList[length - 1][this.keyName] = clid
                this.fileList[length - 1].status = status
                this.fileList[length - 1].message = message
            },
            // 上传财产查控申请书
            async uploadFile(file) {
                let i = 0
                let clid = await this.myId(i)
                let fd = new FormData();
                let f = file.file;
                if(this.isBQ){
                    fd.append("bqid", this.id);
                }else{
                    fd.append("dbid", this.id);
                }
                fd.append("cllx", this.cllx);
                fd.append("files", f);
                fd.append("clid", clid);
                this.uploadStatus(clid, 'uploading', '上传中...')
                this.$axios.post(this.uploadUrl, fd)
                    .then(res => {
                        if (res.code == 200) {
                            this.uploadStatus(clid)
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(() => {
                    this.uploadStatus(clid, 'failed', '上传失败')
                });
            },
            // 上传验证
            beforeRead(file) {
                if (file.size == 0) {
                    Notify('上传文件必须大于0kb!')
                }
                let fileType = "image/jpeg||image/jpg||image/bmp||image/gif||image/png"
                let imgFormat = "jpg、png、jpeg、bmp、gif"
                if (fileType.indexOf(file.type) === -1) {
                    Notify({
                        message: `仅支持格式为${imgFormat}的图片!`,
                        type: 'danger',
                        duration: 5 * 1000
                    })
                    return false;
                } else if (file.size > (20 * 1024 * 1024)) {
                    Notify('上传文件大小不能超过 20MB!')
                    return false;
                }
                return true;
            },
            // 删除材料
            deleteCl: function (file) {
                this.$axios.delete(`${this.delUrl}?id=${file[this.keyName]}`)
                    .then(res => {
                        if (res.code == 200) {
                            this.fileList.forEach((value, index) => {
                                if (value[this.keyName] === file[this.keyName]) {
                                    this.fileList.splice(index, 1)
                                }
                            })
                            this.$notify({'type': 'success', 'message': '材料删除成功'});
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(() => {
                    this.$notify("系统异常");
                });
            },
            myId(i) {
                return new Promise((resolve) => {
                    i++
                    if (i > 3) {
                        this.$notify("系统异常");
                    } else {
                        this.getId().then((res) => {
                            resolve(res.data);
                        }).catch(() => {
                            this.myId(i)
                        })
                    }
                })
            },
            getId() {
                return new Promise((resolve) => {
                    this.$axios.get("ssbq/api/id")
                        .then(res => {
                            if (res.code == 200) {
                                resolve(res);
                            } else {
                                this.$notify(res.message);
                            }
                        }).catch(() => {
                        this.$notify("系统异常");
                    });
                });
            },

        },
        created(){
            setTimeout(()=>{
                this.list.map((item)=>{
                    this.fileList.push({...item})
                })
            },100)
        },
    }
</script>

<style scoped>

</style>